export const defaultItem = {
  id: 'default',
  name: 'nichts ausgewählt',
  icon: 'skull-crossbones',
};

export const items = {
  scissors: {
    id: 'scissors',
    name: 'Schere',
    icon: 'hand-scissors',
    keyP1: 'a',
    keyP2: 'j',
  },
  rock: {
    id: 'rock',
    name: 'Stein',
    icon: 'hand-rock',
    keyP1: 's',
    keyP2: 'k',
  },
  paper: {
    id: 'paper',
    name: 'Papier',
    icon: 'hand-paper',
    keyP1: 'd',
    keyP2: 'l',
  },
  well: {
    id: 'well',
    name: 'Brunnen',
    icon: 'hand-holding-water',
    keyP1: 'f',
    keyP2: 'ö',
  },
};


export const games = [
  {
    name: 'Schere, Stein, Papier',
    description: 'Schere, Stein, Papier und Licht ist für kleine Kinder nicht',
    items: ['scissors', 'rock', 'paper'].map(id => items[id]),
    winMatrix: {
      rock: ['scissors'],
      scissors: ['paper'],
      paper: ['rock'],
    },
  },
  {
    name: 'Stein, Stein, Stein™',
    description: 'das Original – oft kopiert, nie erreicht',
    items: ['rock'].map(id => items[id]),
    winMatrix: {},
  },
  {
    name: 'Schere, Stein, Papier, Brunnen?',
    description: 'die komplizierte Variante für unterwegs',
    items: ['scissors', 'rock', 'paper', 'well'].map(id => items[id]),
    winMatrix: {
      rock: ['scissors'],
      scissors: ['paper'],
      paper: ['rock', 'well'],
      well: ['scissors', 'rock'],
    },
  },
];
